import React from "react";
import { ChatBubble } from "design_system/Icon";
import { NavBar as DSNav } from "widgets/NavBar";
import { Text } from "design_system/Text";
import { Color } from "../../utils/enums";
import { NAV_MENU_V3_ENGAGEMENTS } from "./constants";
import { recordPatientAppClickEngagement } from "../../utils/engagements";

interface ChatCtaV3Props {
    className?: string;
}
export const ChatCtaV3 = ({ className = "ml-auto" }: ChatCtaV3Props) => {
    return (
        <DSNav.TopBar.Link
            leadingIcon={<ChatBubble color={Color.WHITE} aria-hidden="true" />}
            aria-label={gettext("Open chat")}
            className={`_get_help_btn ${className}`}
            onClick={() => recordPatientAppClickEngagement(NAV_MENU_V3_ENGAGEMENTS.LIVE_CHAT_BTN)}
        >
            <Text>{gettext("Live chat")}</Text>
        </DSNav.TopBar.Link>
    );
};
